import { AppFormAction as AppFormActionProps } from 'api/index'
import { AppFormAction } from 'components/AppFormLayout'
import React from 'react'
export interface ActionFunction {
	// 常用固定动作
	// AppGird
	// 新增行
	addRow?: () => void
	// 删除行
	delRow?: () => void
	// 打印
	Print?: () => void
	// 导出
	export?: () => void
	// AppForm
	// 保存
	saveForm?: () => void
	// 保存&关闭
	saveFormClose?: () => void
	// 保存&新增
	saveFormAdd?: () => void
	// 保存&返回
	saveFormReturn?: () => void
	// 返回
	FormReturn?: () => void
	// 下一步
	FormForward?: () => void
	// 上一步
	FormBack?: () => void
	customer?: (functionName: string) => void
}
interface Props extends ActionFunction {
	appFormActionList: AppFormActionProps[]
}
export const AppFormMenu = (props: Props) => {
	return (
		<div className="app-form-menu-new">
			<div className="app-form-menu-toolbar" style={{ display: 'block', width: '100%', bottom: '4px' }}>
				<ul className="app-form-menu-list">
					{props.appFormActionList &&
						props.appFormActionList.map((appFormAction: AppFormActionProps, index: number) => {
							return <AppFormAction key={index} {...appFormAction} {...(props as ActionFunction)} />
						})}
				</ul>
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/AppFormLayout/AppFormMenu.tsx